import { IPropsBusinessPage } from '../Business';
import { OrderTickets } from '../../../shared/components/SconApp/orderTickets/OrderTickets';

export const BusinessOrderTickets: React.FC<IPropsBusinessPage> = ({ business }) => (
  <OrderTickets business={business} />
);
